import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from '../Context/TranslationContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  ChevronRight, 
  Play, 
  ArrowDown, 
  ArrowRight, 
  ChevronDown,
  ArrowUp 
} from 'lucide-react';
import HeroSection from '../components/herosection';
import mediaData from '../MediaData.json';
import YouthProgramSection from './YouthProgram';
import WhatsNew from './whatsnew';
import VideoSection from '../components/VideoSection';
const ScoutHomepage = () => {
  const { isTamil } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [expandedCards, setExpandedCards] = useState({});
  const [showAllNews, setShowAllNews] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showBackToTop, setShowBackToTop] = useState(false);

  const translations = {
    title: {
      en: (
        <>
          Creating transformative learning experiences for young people, everywhere.<br />
        </>
      ),
      ta: "எங்கும் இளைஞர்களுக்கான மாற்றமளிக்கும் கற்றல் அனுபவங்களை உருவாக்குகிறோம்."
    },
    learnMore: {
      en: "Scout and Guide Movement",
      ta: "சாரணர் மற்றும் வழிகாட்டி இயக்கம்"
    },
    featuredStories: {
      en: "Featured Stories",
      ta: "சிறப்பு கதைகள்"
    },
    whatsNew: {
      en: "What's New",
      ta: "புதியவை"
    },
    circulars: {
      en: "Latest Circulars",
      ta: "சமீபத்திய சுற்றறிக்கைகள்"
    },
    featuredStoryTitles: {
      story1: {
        en: "",
        ta: ""
      },
      story2: {
        en: "",
        ta: ""
      },
      story3: {
        en: "",
        ta: ""
      }
    },
    scoutPrograms: {
      en: " Youth Programme",
      ta: " இளைஞர் திட்டம்"
    },
    learnMorePrograms: {
      en: "Want to learn more about the Scout and Guide programs?",
      ta: "சாரணர் மற்றும் வழிகாட்டி திட்டங்கள் பற்றி மேலும் அறிய விரும்புகிறீர்களா?"
    },
    bunny: {
      name: { en: "Bunny/Bulbul", ta: "பன்னி/புல்புல்" },
      ageRange: { en: "Ages: 3 to 6 yrs", ta: "வயது: 3 முதல் 6 வயது வரை" },
      motto: { en: "Motto: Keep Smiling", ta: "குறிக்கோள்: புன்னகையுடன் இருங்கள்" }
    },
    cubBulbul: {
      name: { en: "Cub/BulBul", ta: "கப்/புல்புல்" },
      ageRange: { en: "Ages: 5+ to 10 yrs", ta: "வயது: 5+ முதல் 10 வயது வரை" },
      motto: { en: "Motto: Do Your Best", ta: "குறிக்கோள்: சிறப்பாக செய்யுங்கள்" }
    },
    scoutGuide: {
      name: { en: "Scout/Guide", ta: "சாரணர்/சாரணியர்" },
      ageRange: { en: "Ages: 10+ to 17 yrs", ta: "வயது: 10+ முதல் 17 வயது வரை" },
      motto: { en: "Motto: Be Prepared", ta: "குறிக்கோள்: தயாராக இருங்கள்" }
    },
    roverRanger: {
      name: { en: "Rover/Ranger", ta: "ரோவர்/ரேஞ்சர்" },
      ageRange: { en: "Ages: 15 to 25 yrs", ta: "வயது: 15 முதல் 25 வயது வரை" },
      motto: { en: "Motto: Service", ta: "குறிக்கோள்: சேவை" }
    },
    latestNews: {
      en: "Latest News",
      ta: "சமீபத்திய செய்திகள்"
    },
    watchScoutingStories: {
      en: "Watch Scouts and Guides Stories",
      ta: "சாரண மற்றும் வழிகாட்டி கதைகளைப் பாருங்கள்"
    },
    newOrganization: {
      title: {
        en: "New Organization",
        ta: "புதிய அமைப்பு"
      },
      description: {
        en: "Scouting and Guiding are the world's leading educational youth Movements empowering 57 million young people and volunteers to be active global citizens and agents of change in their communities.",
        ta: "சாரணம் மற்றும் வழிகாட்டி உலகின் முன்னணி கல்வி இளைஞர் இயக்கங்களாகும், 57 மில்லியன் இளைஞர்கள் மற்றும் தொண்டர்களை செயல்பாட்டிற்காக உலகளாவிய குடிமக்களாகவும், தங்கள் சமூகங்களில் மாற்றங்களை செய்யும் ஏஜெண்ட்களாகவும் உருக்கொடுக்கின்றன."
      }
    },
    readMore: {
      en: "Read more",
      ta: "மேலும் படிக்க"
    },
    readLess: {
      en: "Read less",
      ta: "குறைவாக படிக்க"
    },
    watchVideo: {
      en: "Watch Video",
      ta: "காணொளியைப் பார்க்க"
    },
    seeAllNews: {
      en: "See All News",
      ta: "அனைத்து செய்திகளையும் காண்க"
    },
    showLess: {
      en: "Show Less",
      ta: "குறைவாகக் காட்டு"
    },
    videoDescription: {
      en: "Description of the scouting and guiding story video",
      ta: "சாரண மற்றும் வழிகாட்டி கதை வீடியோவின் விளக்கம்"
    }
  };

  const circulars = [
    {
      id: 1,
      title: {
        en: "Annual State Level Camp Registration Open",
        ta: "வருடாந்திர மாநில அளவிலான முகாம் பதிவு திறந்துள்ளது"
      },
      date: "2024-03-15",
      link: "/circulars/state-camp-2024",
      pdfName: "state-camp-2024.pdf"
    },
    {
      id: 2,
      title: {
        en: "New Badge Requirements for Senior Scouts",
        ta: "மூத்த சாரணர்களுக்கான புதிய பேட்ஜ் தேவைகள்"
      },
      date: "2024-03-10",
      link: "/circulars/badge-requirements",
      pdfName: "badge-requirements.pdf"
    },
    {
      id: 3,
      title: {
        en: "District Level Competition Guidelines Released",
        ta: "மாவட்ட அளவிலான போட்டி வழிகாட்டுதல்கள் வெளியிடப்பட்டன"
      },
      date: "2024-03-05",
      link: "/circulars/district-guidelines",
      pdfName: "district-guidelines.pdf"
    },
    {
      id: 4,
      title: {
        en: "Summer Camp Schedule Announced",
        ta: "கோடை முகாம் அட்டவணை அறிவிக்கப்பட்டது"
      },
      date: "2024-03-01",
      link: "/circulars/summer-camp",
      pdfName: "summer-camp.pdf"
    }
  ];
  const newsContent = [
    {
      title: "Diamond Jubilee 2025",
      titleTa: "வைர விழா 2025",
      description: "The Honorable Minister of School Education, Mr. Anbil Mahesh Poyyamozhi, personally inspected the preparations for the Diamond Jubilee of the Bharata Sarana Scout Movement and the Mutthamizharinagar Kalaignar Centenary Commemoration Gala to be held in January 2025 at Manapparai, Trichy. District Collector Mr. Pradeep Kumar I.A.C., Legislative Assembly Members Mr. Palaniandi, Mr. Abdul Samadhu, and Chief Commissioner Mr. Arivoli participated in the event.",
      descriptionTa: "மாண்புமிகு பள்ளிக் கல்வித் துறை அமைச்சர் திரு.அன்பில் மகேஸ் பொய்யாமொழி அவர்கள் திருச்சி மணப்பாறையில் வருகின்ற  ஜனவரி 2025 இல் நடைபெறவிருக்கும் பாரத சாரண சாரணியர் இயக்கத்தின் வைரவிழா மற்றும் முத்தமிழறிஞர் கலைஞர் நூற்றாண்டு நினைவு பெருந்திரளணி நிகழ்வின் முன்னேற்பாடு பணிகளை நேரில் சென்று பார்வையிட்டு ஆய்வு செய்தார் இந்நிகழ்வில் சட்டமன்ற உறுப்பினர்கள் திரு.பழனியாண்டி, திரு.அப்துல் சமது,  முதன்மை ஆணையர் திரு.அறிவொளி ஆகியோர் கலந்துகொண்டார்கள்."
    },
    {
      title: " Leaders Training Camp 2023",
      titleTa: "தலைவர்கள் பயிற்சி முகாம் 2023",
      description: "The Team Leaders Training Camp 2023, organized by Tamil Nadu Scouts and Guides, is a pivotal event designed to nurture and empower the next generation of scout and guide leaders. This intensive camp brings together aspiring and current team leaders from across the state for a comprehensive leadership development program. Participants engage in workshops, team-building exercises, and practical outdoor activities that enhance their leadership skills.",
      descriptionTa: "தமிழ்நாடு சாரணர்கள் மற்றும் வழிகாட்டிகளால் ஏற்பாடு செய்யப்பட்ட அணித் தலைவர்கள் பயிற்சி முகாம் 2023, அடுத்த தலைமுறை சாரணர் மற்றும் வழிகாட்டி தலைவர்களை வளர்த்தெடுக்கவும் அதிகாரம் அளிக்கவும் வடிவமைக்கப்பட்ட ஒரு முக்கியமான நிகழ்வாகும். இந்த தீவிர முகாம் மாநிலம் முழுவதிலுமிருந்து ஆர்வமுள்ள மற்றும் தற்போதைய அணித் தலைவர்களை ஒரு விரிவான தலைமைத்துவ மேம்பாட்டுத் திட்டத்திற்காக ஒன்றிணைக்கிறது. பங்கேற்பாளர்கள் தங்கள் தலைமைத்துவ திறன்களை மேம்படுத்தும் பயிலரங்குகள், அணி உருவாக்கும் பயிற்சிகள் மற்றும் நடைமுறை வெளிப்புற செயல்பாடுகளில் ஈடுபடுகிறார்கள்.",
    },
    {
      title: "Rastrapati Award Certificate Test Camp 2023",
      titleTa: "ராஷ்டிரபதி விருது சான்றிதழ் சோதனை முகாம் 2023",
      description: "The Rastrapati Award Certificate Test Camp 2023 in Tamil Nadu is a prestigious event for senior scouts and guides aiming to achieve the highest honor in Indian Scouting and Guiding. This rigorous camp, typically held annually, evaluates candidates on their leadership skills, outdoor expertise, and commitment to scouting and guiding values. Participants face various challenges designed to test their physical endurance, mental acuity, and practical scouting and guiding knowledge.",
      descriptionTa: " ராஷ்டிரபதி விருது சான்றிதழ் சோதனை முகாம் 2023 என்பது இந்திய சாரணர் மற்றும் வழிகாட்டி துறையில் உயரிய பெருமையை அடையும் நோக்கத்தில் மூத்த சாரணர்கள் மற்றும் வழிகாட்டிகளுக்கான மதிப்புமிக்க நிகழ்வாகும். இந்த கடுமையான முகாம், பொதுவாக ஆண்டுதோறும் நடத்தப்படுகிறது, வேட்பாளர்களின் தலைமைத்துவ திறன்கள், வெளிப்புற நிபுணத்துவம் மற்றும் சாரணர் மற்றும் வழிகாட்டி மதிப்புகளுக்கான அர்ப்பணிப்பு ஆகியவற்றை மதிப்பீடு செய்கிறது. பங்கேற்பாளர்கள் தங்கள் உடல் தாங்கும் திறன், மன கூர்மை மற்றும் நடைமுறை சாரணர் மற்றும் வழிகாட்டி அறிவைச் சோதிக்க வடிவமைக்கப்பட்ட பல்வேறு சவால்களை எதிர்கொள்கின்றனர்.",
    },
    {
      title: "Chaturtha Charan / Heerak Bunk Exam Camps",
      titleTa: "சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள்",
      description: "Chaturtha Charan / Heerak Bunk Selection Camps are important events of Scouting and Guiding in India. These camps are considered high-level exams for senior scouts and guides. Participants are rigorously tested on their scouting and guiding skills, leadership qualities, community service and knowledge of environmental protection.",
      descriptionTa: "சதுர்த்த சரண் / ஹீரக் பங்க் தேர்வு முகாம்கள் என்பது இந்திய சாரணர் மற்றும் வழிகாட்டி இயக்கத்தின் முக்கியமான நிகழ்வுகளாகும். இந்த முகாம்கள் மூத்த சாரணர்கள் மற்றும் வழிகாட்டிகளுக்கான உயர்நிலை தேர்வுகளாக கருதப்படுகின்றன. பங்கேற்பாளர்கள் தங்கள் சாரணர் மற்றும் வழிகாட்டிப் பண்புகள், தலைமைத்துவ பண்புகள், சமூக சேவை மற்றும் சுற்றுச்சூழல் பாதுகாப்பு பற்றிய அறிவு ஆகியவற்றில் கடுமையாக சோதிக்கப்படுகிறார்கள்.",
    },
    {
      title: "World Thought Day -2024",
      titleTa: "உலக சிந்தனை நாள் -2024",
      description: "World Thought Day-2024 is an important event for India Scouts and Guides. Celebrated every year on 22nd February, the day emphasizes the global brotherhood of scouts and guides. On this day, scouts and guides across India engage in activities promoting environmental protection and peace.",
      descriptionTa: "உலக சிந்தனை நாள் -2024 ஆனது பாரத சாரணர்கள் மற்றும் வழிகாட்டிகளின் முக்கிய நிகழ்வாகும். ஒவ்வொரு ஆண்டும் பிப்ரவரி 22 அன்று கொண்டாடப்படும் இந்த நாள், உலகளாவிய சாரணர் மற்றும் வழிகாட்டி சகோதரத்துவத்தை வலியுறுத்துகிறது. இந்த நாளில், இந்தியா முழுவதும் உள்ள சாரணர்கள் மற்றும் வழிகாட்டிகள் சுற்றுச்சூழல் பாதுகாப்பு மற்றும் அமைதியை ஊக்குவிக்கும் செயல்பாடுகளில் ஈடுபடுவார்கள்.",
    },
    {
      title: "National Integration Camp 2024",
      titleTa: "தேசிய ஒருங்கிணைப்பு முகாம் 2024",
      description: "The National Integration Camp brings together scouts and guides from different states of India to promote unity in diversity. The camp features cultural exchanges, joint activities, and programs that help scouts and guides understand and appreciate India's diverse heritage. Participants learn about different customs, traditions, and languages while building lasting friendships.",
      descriptionTa: "தேசிய ஒருங்கிணைப்பு முகாம் பன்முகத்தன்மையில் ஒற்றுமையை ஊக்குவிக்க இந்தியாவின் பல்வேறு மாநிலங்களைச் சேர்ந்த சாரணர்கள் மற்றும் வழிகாட்டிகளை ஒன்றிணைக்கிறது. இந்த முகாமில் கலாச்சார பரிமாற்றங்கள், கூட்டு நடவடிக்கைகள் மற்றும் சாரணர்கள் மற்றும் வழிகாட்டிகள் இந்தியாவின் பன்முக பாரம்பரியத்தைப் புரிந்துகொள்ளவும் பாராட்டவும் உதவும் நிகழ்ச்சிகள் இடம்பெறும். பங்கேற்பாளர்கள் நீடித்த நட்புறவை வளர்த்துக்கொள்வதோடு வெவ்வேறு பழக்கவழக்கங்கள், பாரம்பரியங்கள் மற்றும் மொழிகளைப் பற்றியும் கற்றுக்கொள்கிறார்கள்.",
    }
  ];

  const programsData = [
    {
      key: 'bunny',
      image: "/Images/bunny.png",
      link: "/programs",
      className: "transform hover:scale-105 transition-transform duration-300"
    },
    {
      key: 'cubBulbul',
      image: "/Images/bulbul.png",
      link: "/programs",
      className: "transform hover:scale-105 transition-transform duration-300"
    },
    {
      key: 'scoutGuide',
      image: "/Images/BSGlogo.png",
      link: "/programs",
      className: "transform hover:scale-105 transition-transform duration-300"
    },
    {
      key: 'roverRanger',
      image: "/Images/rover.png",
      link: "/programs",
      className: "transform hover:scale-105 transition-transform duration-300"
    }
  ];

  const videoSectionRef = useRef(null);
  const storiesSectionRef = useRef(null);
  const [lastCircularIndex, setLastCircularIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLastCircularIndex((prev) => (prev + 1) % circulars.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % 3); // Assuming 3 slides
  };
  
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + 3) % 3); // Assuming 3 slides
  };
  
  // Add this effect for auto-sliding
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 3);
    }, 5000); // Change slide every 5 seconds
  
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      const progress = (currentScrollY / (documentHeight - windowHeight)) * 100;
      setScrollProgress(progress);
      setIsNavVisible(currentScrollY < lastScrollY || currentScrollY < 100);
      setLastScrollY(currentScrollY);
      setShowBackToTop(currentScrollY > windowHeight / 2);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % mediaData.carouselImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const toggleCardExpansion = (index) => {
    setExpandedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

return (
  <div className="relative bg-[#FDFBF8] overflow-x-hidden mt-20">
    {/* Scroll Progress Indicator */}
    <div 
      className="fixed top-0 left-0 w-full h-1 bg-gray-200 z-50"
      style={{ transform: `scaleX(${scrollProgress / 100})` }}
    >
      <div className="h-full bg-gradient-to-r from-[#e7dd7a] to-[#ec0a0e] transform origin-left"/>
    </div>

    <HeroSection/>
    
    {/* Featured Stories Section */}
    <section 
      ref={storiesSectionRef}
      className="py-24 bg-white"
    >
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className={`text-[#2C251D] ${
            isTamil 
              ? 'text-3xl md:text-4xl'
              : 'text-4xl md:text-5xl'
          }`}>
            {translations.featuredStories[isTamil ? 'ta' : 'en']}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {mediaData.featuredStories.map((story, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={story}
                  alt={translations.featuredStoryTitles[`story${index + 1}`][isTamil ? 'ta' : 'en']}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-xl font-medium mb-2">
                  {translations.featuredStoryTitles[`story${index + 1}`][isTamil ? 'ta' : 'en']}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
    
    <WhatsNew isTamil={isTamil} />
    
    <YouthProgramSection/>

    {/* Video Section - Added Here */}
    <VideoSection isTamil={isTamil} />

    {/* Latest News Section
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className={`text-[#2C251D] ${
            isTamil 
              ? 'text-3xl md:text-4xl'
              : 'text-4xl md:text-5xl'
          }`}>
            {translations.latestNews[isTamil ? 'ta' : 'en']}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsContent.slice(0, showAllNews ? undefined : 3).map((news, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-video relative overflow-hidden">
                <img
                  src={mediaData.newsImages[index % mediaData.newsImages.length]}
                  alt={isTamil ? news.titleTa : news.title}
                  className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-medium text-[#2C251D] mb-4">
                  {isTamil ? news.titleTa : news.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {expandedCards[index]
                    ? (isTamil ? news.descriptionTa : news.description)
                    : (isTamil ? news.descriptionTa.slice(0, 150) : news.description.slice(0, 150)) + "..."}
                </p>
                <button
                  onClick={() => toggleCardExpansion(index)}
                  className="inline-flex items-center gap-2 text-[#8A7968] font-medium hover:text-[#726354]"
                >
                  {expandedCards[index]
                    ? translations.readLess[isTamil ? 'ta' : 'en']
                    : translations.readMore[isTamil ? 'ta' : 'en']}
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-center mt-12"
        >
          <button
            onClick={() => setShowAllNews(!showAllNews)}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#8A7968] text-white rounded-full
                     hover:bg-[#726354] transition-all duration-300 shadow-lg hover:shadow-xl
                     transform hover:-translate-y-1"
          >
            <span>
              {showAllNews
                ? translations.showLess[isTamil ? 'ta' : 'en']
                : translations.seeAllNews[isTamil ? 'ta' : 'en']}
            </span>
            <ChevronRight className="w-5 h-5" />
          </button>
        </motion.div>
      </div>
    </section> */}

    {/* Back to Top Button */}
    <AnimatePresence>
      {showBackToTop && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 p-4 bg-[#8A7968] hover:bg-[#726354] 
                   text-white rounded-full shadow-lg hover:shadow-xl 
                   transform hover:-translate-y-1 transition-all duration-300"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <ArrowUp className="w-6 h-6" />
          <span className="sr-only">Back to top</span>
        </motion.button>
      )}
    </AnimatePresence>
  </div>
);
};

export default ScoutHomepage;